export { default as usePaginatedTags } from './usePaginatedTags';
